"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Logo = props => {
  const {
    logo: {
      url,
      width,
      height
    },
    title
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, url ? /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-inner-wrap"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    alt: title,
    width: width,
    height: height,
    className: "logo-margin"
  }), title) : /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-inner-wrap"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "FabricLogoName",
    className: "logo-margin"
  })));
};

Logo.propTypes = {
  logo: _propTypes.default.shape({
    width: _propTypes.default.string.required,
    height: _propTypes.default.string.required,
    url: _propTypes.default.string.required
  }),
  title: _propTypes.default.string
};
Logo.defaultProps = {
  logo: {
    url: '',
    width: '18px',
    height: '18px'
  }
};
var _default = Logo;
exports.default = _default;